import React, {useContext, useState, useId} from 'react'
import {Badge, Collapse, Divider} from "antd";
import {
    ChevronRightRounded,
    FilterListRounded
} from "@mui/icons-material";
import {BrandContext} from "@context/BrandContext";
import Button from "./Button";
import {TemplateContext} from "@context/TemplateContext";
import {useIndexRoving} from "@hooks/useIndexRoving";

const TableFilterControls = ({ primaryFilterItem, startOpen = true, filterContent, showFilterButton, showFilterIcon = true, filterCount = 0, filterButtonHeading = 'Filter' }) => {
    const brandConfig = useContext(BrandContext);
    const {bodyComponentName} = useContext(TemplateContext);
    const id = useId()

    const isUSAWithAllowedComponent = brandConfig.brandCode === 'USA' &&
        bodyComponentName !== 'SchoolManagementTabs' &&
        bodyComponentName !== 'Reports';

    const [activeKey, setActiveKey] = useState((isUSAWithAllowedComponent || !startOpen) ? null : '1');
    const [isOpen, setOpen] = useState((!isUSAWithAllowedComponent && startOpen));

    const handleButtonClick = () => {
        if(activeKey) {
            setActiveKey(null);
            setOpen(false);
        } else {
            setActiveKey("1");
            setOpen(true);
        }
    };
    const { ref, onKeyDown, onFocus, onClick } = useIndexRoving('input');
    const filterItems = [
        {
            key: '1',
            label: 'Filter',
            styles: { body: { padding: 0 } },
            children: (
                <div id={"filter-content"+id} role="region" aria-labelledby={isUSAWithAllowedComponent || showFilterButton ? "filter-button"+id : ''}>
                    {filterContent}
                </div>
            ),
        }
    ]

    return(
    <section aria-label="Table Filters">
        <header className={'ch-table-filter-collapse-primary-select-wrapper'} style={{display: 'flex'}}>
            {primaryFilterItem && primaryFilterItem}
            {(primaryFilterItem && showFilterButton) &&
                <Divider orientation={'vertical'} style={{height: 'auto'}} />
            }
            {((brandConfig.brandCode === 'USA' && bodyComponentName !== 'SchoolManagementTabs' && bodyComponentName !== 'Reports') || showFilterButton) &&
                <Button
                    tabIndex={0}
                    id={'filter-button'+id}
                    className={'margin--s'}
                    aria-controls={'filter-content'+id}
                    aria-expanded={isOpen}
                    type={'outline'}
                    onClick={handleButtonClick}
                >
                        <span className={'ch-filter-form-button-content'}>
                            {showFilterIcon && <FilterListRounded />}
                            {filterButtonHeading}
                            {filterCount ? <Badge title={''} count={filterCount} style={{backgroundColor: 'var(--icon-colour)'}} /> : null}
                            <ChevronRightRounded
                                style={{
                                    transform: isOpen ? 'rotate(270deg)' : 'rotate(90deg)',
                                    transition:'var(--ani-mid) ease'}}
                            />
                        </span>
                </Button>
            }
        </header>
        <div ref={ref} onKeyDown={onKeyDown} onFocus={onFocus} onClick={onClick}>
            <Collapse activeKey={activeKey} accordion ghost items={filterItems} size={"small"} className={'ch-table-filter-collapse-nostyle'} />
        </div>
    </section>
)
}

export default TableFilterControls;